export function getJSON(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (e) {
    return fallback;
  }
}

export function setJSON(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {}
}

export function removeKey(key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {}
}

/* -------------------- Active user cart key -------------------- */
let activeUserId = null;

function cartKey(userId) {
  const id = userId == null ? "" : String(userId).trim();
  return id ? `cart_user_${id}` : "cart_guest";
}

// Call this when login/logout/user changes
export function setCartUser(userId) {
  activeUserId = userId == null ? null : String(userId);
}

export function loadCart() {
  const c = getJSON(cartKey(activeUserId), []);
  return Array.isArray(c) ? c : [];
}

export function saveCart(cart) {
  setJSON(cartKey(activeUserId), Array.isArray(cart) ? cart : []);
}

export function clearCart() {
  setJSON(cartKey(activeUserId), []);
}

/* -------------------- Cart helpers -------------------- */
export function addToCart(cart, itemId, qty) {
  const id = String(itemId);
  const q = Number(qty || 1);
  const delta = Number.isFinite(q) ? q : 1;

  const next = Array.isArray(cart) ? [...cart] : [];
  const idx = next.findIndex((x) => String(x.id) === id);

  if (idx >= 0) {
    next[idx] = {
      ...next[idx],
      quantity: Number(next[idx].quantity || 0) + delta,
    };
  } else {
    next.push({ id, quantity: delta });
  }

  return next.filter((x) => Number(x.quantity || 0) > 0);
}

export function setQty(cart, itemId, qty) {
  const id = String(itemId);
  const q = Number(qty);

  const next = Array.isArray(cart) ? [...cart] : [];
  const idx = next.findIndex((x) => String(x.id) === id);

  if (idx < 0) return next;

  if (!Number.isFinite(q) || q <= 0) {
    return next.filter((x) => String(x.id) !== id);
  }

  next[idx] = { ...next[idx], quantity: q };
  return next;
}
